<template>
    <div>
        <label :for="name" class="color-black">{{ title }}</label>
        <input @input="updateValue" :id="name" :max="max" :min="min" :step="step" type="range"
               :value="getValue"> {{ getValue }}
        <small class="form-text text-muted">{{ help }}</small>
    </div>
</template>

<script>
    export default {
        name: "RangeInput",
        props: [
            'help',
            'name',
            'title',
            'min',
            'max',
            'step',
            'startValue',
            'storeCommitName',
            'storeValueName'
        ],
        computed: {
          getValue() {
            return this.$store.state[this.storeValueName]
          }
        },
        methods: {
          updateValue(event) {
            this.$store.commit(this.storeCommitName, {value: event.target.value});
          }
        }
    }
</script>

<style scoped lang="scss">
    input[type=range] {
        -webkit-appearance: none; /* Hides the slider so that custom slider can be made */
        width: 100%; /* Specific width is required for Firefox. */
        background: transparent; /* Otherwise white in Chrome */
        height: 1px;
        cursor: pointer;
        background: $black;
    }

    input[type=range]:focus {
        outline: none; /* Removes the blue border. You should probably do some kind of focus styling for accessibility reasons though. */
    }

    input[type=range]::-ms-track {
        width: 100%;
        cursor: pointer;

        /* Hides the slider so custom styles can be added */
        background: transparent;
        border-color: transparent;
        color: transparent;
    }

    input[type=range]::-webkit-slider-thumb {
      -webkit-appearance: none;
      border: none;
      border-radius: 50%;
      height: 1.25rem;
      width: 1.25rem;
      background-color: $primary;
      color: $primary;
      cursor: pointer;
    }

    input[type=range]::-moz-range-thumb {
        border: none;
        border-radius: 50%;
        height: 1.25rem;
        width: 1.25rem;
        background-color: $primary;
        color: $primary;
        cursor: pointer;
        margin-top: -.625rem; /* You need to specify a margin in Chrome, but in Firefox and IE it is automatic */
    }

    input[type=range]::-moz-range-thumb,
    input[type=range]::-ms-thumb {
        border: none;
        border-radius: 50%;
        height: 1.25rem;
        width: 1.25rem;
        background: $black;
        cursor: pointer;
        margin-top: -14px; /* You need to specify a margin in Chrome, but in Firefox and IE it is automatic */
    }

    input[type=range]::-webkit-slider-runnable-track, input[type=range]::-moz-range-track {
        width: 100%;
        height: 1px;
        cursor: pointer;
        background: $black;
    }
</style>
